import { useSubscriptionOfferReject } from "@/api";
import { useToast } from "@/components/ui/use-toast";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";

export function useHandleSubscriptionOfferReject({
  subscriptionOfferId
}: {
  subscriptionOfferId: string;
}) {
  const [loadingResolveReject, setLoadingResolveReject] = useState(false);

  const { toast } = useToast();
  const navigate = useNavigate();
  const [subscriptionOfferReject] = useSubscriptionOfferReject({
    subscriptionOfferId
  });

  function errorToast() {
    toast({
      title: "Unable to reject subscription offer",
      description:
        "An error occurred while rejecting the subscription offer. Please try again or report the issue."
    });
  }

  function handleReject() {
    setLoadingResolveReject(true);

    subscriptionOfferReject()
      .then((res) => {
        if (res.errors) {
          console.error("Subscription offer reject errors:", res.errors);
          errorToast();
        }

        switch (res.data?.subscriptionOfferReject.__typename) {
          case "SubscriptionOffer": {
            toast({
              title: "Subscription offer rejected"
            });
            navigate({ to: "/organization" });
            break;
          }
          case "SubscriptionOfferInvalidStatus": {
            toast({
              title: "Invalid subscription offer",
              variant: "destructive",
              description:
                "The subscription offer is no longer valid. It has previosly been accepted, rejected, withdrawn or expired."
            });
            break;
          }
          case "SubscriptionOfferNotFound": {
            toast({
              title: "Subscription offer not found",
              variant: "destructive",
              description: "The subscription offer does not exist."
            });
            break;
          }
          default:
            errorToast();
        }
      })
      .catch((error) => {
        console.error("Subscription offer reject error:", error);
        errorToast();
      })
      .finally(() => setLoadingResolveReject(false));
  }

  return { handleReject, loadingResolveReject };
}
